module.exports = __webpack_public_path__ + "img/134.67dd4bcc.svg";